const hora = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });
const diaMes = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' });
const diaLongo = new Intl.DateTimeFormat('pt-BR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});

const mesmoDia = (a: Date, b: Date) => a.toDateString() === b.toDateString();

export function quandoCurto(iso: string, agora = new Date()): string {
  const d = new Date(iso);
  if (mesmoDia(d, agora)) return hora.format(d);
  const ontem = new Date(agora);
  ontem.setDate(agora.getDate() - 1);
  if (mesmoDia(d, ontem)) return 'Ontem';
  return diaMes.format(d);
}

export const horaDe = (iso: string) => hora.format(new Date(iso));

export function rotuloDia(iso: string, agora = new Date()): string {
  const d = new Date(iso);
  if (mesmoDia(d, agora)) return 'Hoje';
  const ontem = new Date(agora);
  ontem.setDate(agora.getDate() - 1);
  if (mesmoDia(d, ontem)) return 'Ontem';
  return diaLongo.format(d);
}

export function minutosDesde(iso: string | null, agora = Date.now()): number | null {
  return iso ? Math.max(0, Math.floor((agora - new Date(iso).getTime()) / 60_000)) : null;
}

export function duracaoCurta(min: number): string {
  if (min < 1) return 'agora';
  if (min < 60) return `${min} min`;
  if (min < 60 * 24) return `${Math.floor(min / 60)} h`;
  return `${Math.floor(min / 1440)} d`;
}

export function nivelEspera(
  min: number | null,
  limites: { atencaoMin: number; criticoMin: number } = { atencaoMin: 5, criticoMin: 15 },
): 'ok' | 'atencao' | 'critico' {
  if (min === null || min < limites.atencaoMin) return 'ok';
  return min < limites.criticoMin ? 'atencao' : 'critico';
}
